import type { ParentComponent } from "solid-js";
import { Show } from "solid-js";
import "./Alert.css";
import { Icon } from "./Icon";

type Props = {
	variant: "info" | "warning" | "error";
	icon?: string;
};

/**
 * Display important messages to users with variants for info, warning, and error.
 *
 * [Design System →](http://localhost:5174/component/Alert)
 */
export const Alert: ParentComponent<Props> = (props) => {
	const role = () => (props.variant === "error" ? "alert" : "status");
	const className = () => `gvtui-alert gvtui-alert--${props.variant}`;

	return (
		<div role={role()} class={className()}>
			<Show when={props.icon}>
				<Icon icon={props.icon!} />
			</Show>
			{props.children}
		</div>
	);
};
